export default "__VITE_ASSET__GN2MXV_k__"